(function () {
    'use strict';

    Services.AttachmentsService = class AttachmentsService {

        // @ngInject
        constructor(_, TrackJS) {
            this.TrackJS = TrackJS;
            this._ = _;
        }

        translateFilesListForServer(uploadedFilesList) {
            const translatedList = [];
            if (uploadedFilesList) {
                uploadedFilesList.forEach(file => {
                    if (file.url || file.file_url) {
                        const translatedItem = {
                            url: file.url || file.file_url,
                            type: file.file_type,
                            name: file.asset_name || file.file_name
                        };
                        if (file.cloudinary_public_id) {
                            translatedItem.cloudinary_public_id = file.cloudinary_public_id;
                        }

                        translatedList.push(translatedItem);
                    } else if (file.s3Response) {
                        translatedList.push({
                            url: file.s3Response.url,
                            type: file.type,
                            name: file.name
                        });
                    } else {
                        // else ignore it because we don't know how to handle it
                        this.TrackJS.console.error("failed to find the file URL while sending the message", file);
                    }
                });
            }

            return translatedList;
        }

        getAdditiveAttachments(newImages, newFiles, existingImages, existingFiles) {
            // set the new files as an addition to existing files
            const attachedFiles = {
                images : [],
                files : []
            };

            const concatedImages = (existingImages || []).concat(newImages || []);
            const uniqueImages = this._.uniq(concatedImages, false, function(image) { return image._id});

            const concatedFiles = (existingFiles || []).concat(newFiles  || []);
            const uniqueFiles = this._.uniq(concatedFiles, false, function(file) { return file._id});

            attachedFiles.images = uniqueImages;
            attachedFiles.files = uniqueFiles;

            return attachedFiles;

        }

    };

}());

